import React from 'react';
import { AppRootActions } from '../components/App/types';

const context = React.createContext<AppRootActions>(null);
context.displayName = 'GroupActionsContext';

export const GroupsActionsProvider = context.Provider;
export const GroupsActionsConsumer = context.Consumer;
export default context;
